import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useLocation, useHistory } from "react-router-dom"
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
  Card,
  CardImg,
  CardTitle,
  Modal,
  Collapse,
} from "reactstrap"
import { Carousel } from "react-responsive-carousel"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import * as url from "helpers/url_helper"
import moment from "moment"

//i18n
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

//empty state
import UgiftEmptyState from "./UgiftEmptyState"
import emptyImage from "assets/images/ugifts/icons/empty/empty_order.png"

import logoGiftCard from "assets/images/ugifts/icons/order/giftcard.png"
import logoVoucher from "assets/images/ugifts/icons/order/voucher.png"

import { Button } from "@material-ui/core"

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const UgiftUdollarCardList = props => {
  const query = useQuery()
  const history = useHistory()

  const [token, setToken] = useState(null)
  const [uid, setUid] = useState(null)
  const [shareCodeMessage, setShareCodeMessage] = useState("Share your code")
  const [currency, setCurrency] = useState("")
  const [ucid, setUCid] = useState(null)

  useEffect(() => {
    if (localStorage.getItem("authAPI")) {
      const obj = JSON.parse(localStorage.getItem("authAPI"))
      console.log(
        "storage",
        obj.api_token_expiry + " / " + Math.floor(Date.now() / 1000)
      )
      if (obj.api_token_expiry < Math.floor(Date.now() / 1000)) {
        getToken()
      } else {
        setToken(obj)
      }
    } else {
      getToken()
    }

    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      setUid(obj.member_id)
      console.log(obj)
    }

    if (localStorage.getItem("currency")) {
      setCurrency(localStorage.getItem("currency"))
    }

    if (query.get("id")) {
      setUCid(query.get("id"))
    }
  }, [])

  const getToken = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_api_token")
    urlencoded.append("source", "web")
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Request token", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      setToken(postresponse)
      localStorage.setItem("authAPI", JSON.stringify(postresponse))
      console.log(response.status, token)
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (token != null) {
      // getUserProfile()
      getOrderList()
      console.log("use effect")
    }
  }, [token])

  const [userData, setUserData] = useState(null)
  const getUserProfile = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_profile")
    urlencoded.append("member_id", uid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request category", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setUserData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [orderData, setOrderData] = useState(null)
  const getOrderList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "history_udollar_giftcards")
    urlencoded.append("udollar_id", ucid)
    // urlencoded.append("udollar_id", 6)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request order list", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_BASKET,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setOrderData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Ugift</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col
              xl={6}
              className="mx-auto"
              style={{
                maxWidth: "480px",
                backgroundColor: "white",
                // backgroundImage: `url(${bgImage})`,
                // backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                className="auth-full-page-content"
                style={{
                  minHeight: "100vh",
                  paddingTop: "56px",
                  backgroundColor:
                    orderData && orderData.length > 0 ? "#F5F5F5" : "white",
                  // paddingBottom: "76px",
                }}
              >
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <Row
                      className="m-0 w-100"
                      style={{
                        height: "56px",
                        backgroundColor: "#009FE2",
                        position: "fixed",
                        top: 0,
                        zIndex: 1030,
                        maxWidth: "480px",
                      }}
                    >
                      <Col xs={2} className="ps-0">
                        {/* <Link to="/categories"> */}
                        <Button
                          className="h-100 m-0"
                          onClick={() => {
                            history.goBack()
                          }}
                        >
                          <i className="bx bx-arrow-back align-middle font-size-20 text-white" />
                        </Button>
                        {/* </Link> */}
                      </Col>
                      <Col xs={8} className="align-self-center">
                        <p className="h-100 text-white font-size-15 my-auto text-center">
                          {props.t("UDollar History")}
                        </p>
                      </Col>
                      <Col xs={2} className="pe-0">
                        {/* <Link to="#">
                          <Button className="h-100 m-0">
                            <i className="bx bx-basket align-middle font-size-28 text-white" />
                          </Button>
                        </Link> */}
                      </Col>
                    </Row>
                    {orderData &&
                      orderData.map((data, index) => (
                        <Row className="p-3 pb-0">
                          <Col>
                            {/* <Link to={"/udollar-history?id=" + data.id}> */}
                            <Card className="p-3 mb-0 shadow-none">
                              <Row className="mb-4">
                                <Col>
                                  <span
                                    className="font-weight-14 text-black"
                                    style={{ color: "black" }}
                                  >
                                    {props.t("Date")}
                                  </span>
                                </Col>
                                <Col className="text-end">
                                  <span
                                    className="font-size-14"
                                    style={{
                                      fontWeight: 700,
                                      color: "black",
                                    }}
                                  >
                                    {moment(
                                      data.ordered_date,
                                      "DD/MM/YYYY HH:mm:ss"
                                    ).format("D MMM YYYY HH:mm:ss")}
                                  </span>
                                </Col>
                              </Row>
                              <Row className="mb-4">
                                <Col>
                                  <span
                                    className="font-weight-14 text-black"
                                    style={{ color: "black" }}
                                  >
                                    {props.t("Amount")}
                                  </span>
                                </Col>
                                <Col className="text-end">
                                  <span
                                    className="font-size-14"
                                    style={{
                                      fontWeight: 700,
                                      color: "black",
                                    }}
                                  >
                                    {currency + " " + data.amount}
                                  </span>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <span
                                    className="font-weight-14 text-black"
                                    style={{ color: "black" }}
                                  >
                                    {props.t("Order ID")}
                                  </span>
                                </Col>
                                <Col className="text-end">
                                  <span
                                    className="font-size-14"
                                    style={{
                                      fontWeight: 700,
                                      color: "black",
                                    }}
                                  >
                                    {data.order_no}
                                  </span>
                                </Col>
                              </Row>
                            </Card>
                            {/* </Link> */}
                          </Col>
                        </Row>
                      ))}
                    {orderData && orderData.length == 0 && (
                      <UgiftEmptyState
                        image={emptyImage}
                        title={props.t("No UDollar history yet")}
                        link=""
                        linkText=""
                      />
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(UgiftUdollarCardList)

UgiftUdollarCardList.propTypes = {
  t: PropTypes.any,
}
